import { ChainId } from '@pancakeswap-libs/sdk';
import MULTICALL_ABI from './abi.json';

// nothing i found - P
const MULTICALL_NETWORKS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '0x13305ab992c3BA30a3f2c4B92727eb4cA64063e8', // TODO
  [ChainId.BSCTESTNET]: '0xA5d15131F2d0022d8E4f3A1e963fbA4B719A913B',
};

export { MULTICALL_ABI, MULTICALL_NETWORKS };
